import type { EditAreaTemplateApplication } from '@repo/api-contracts';
import { type MutationError, trpc } from '@/shared/api';

interface Options {
  readonly onSuccess?: (application: EditAreaTemplateApplication) => void;
}

/**
 * 템플릿 적용 — 서버가 상품을 준비(실측 종류·실측·비어 있는 허용 목록)하고 상품 실측에 맞춘 기하를 돌려준다.
 * 편집영역 버전은 만들지 않는다. 호출자가 기하를 초안에 넣고 사진을 채워 저장한다.
 */
export const useApplyEditAreaTemplate = ({ onSuccess }: Options = {}) => {
  const mutation = trpc.productManagement.editAreaTemplates.applyToProduct.useMutation({
    onSuccess,
  });
  const error: MutationError | null = mutation.error;

  return { applyTemplate: mutation.mutate, isPending: mutation.isPending, error };
};
